import React, { useEffect, useState } from 'react';
import FilterSelect from '@/components/atoms/FilterSelect/FilterSelect';
import { Scope, StatType } from '@/types/types';
import { useTranslations } from 'next-intl';

interface ThresholdFilterProps {
  onFilterChange: (filter: { threshold: number }) => void;
  threshold: number | "";
  statType: StatType | "trends" | "";
  scope: Scope | "";
  disabled?: boolean;
}

interface Thresholds {
  team: {
    corners: number[];
    onShots: number[];
    totalShots: number[];
    goals: number[];
    cards: number[];
    results: never[];
    btts: never[];
    trends: any[];
  };
    corners: number[];
    goals: number[];
    onShots: number[];
    totalShots: number[];
    cards: number[];
    results: never[];
    btts: never[];
    trends: any[];
}

const ThresholdFilter: React.FC<ThresholdFilterProps> = ({ onFilterChange, threshold, statType, scope, disabled }) => {
  const [selectedThreshold, setselectedThreshold] = useState<number | "">(threshold);

  const f = useTranslations('filter');

  const thresholds: Thresholds = {
    team : {
      corners: [3.5, 4.5, 5.5, 6.5, 7.5],
      onShots: [3.5, 4.5, 5.5, 6.5, 7.5],
      totalShots: [6.5, 7.5, 8.5, 9.5, 10.5, 11.5, 12.5, 13.5, 14.5, 15.5, 16.5, 17.5],
      goals: [0.5, 1.5, 2.5, 3.5],
      cards: [0.5, 1.5, 2.5, 3.5, 4.5],
      results: [],
      btts: [],
      trends: [0, 10, 20, 30, 40, 50, 60],
    },
    corners: [6.5, 7.5, 8.5, 9.5, 10.5, 11.5, 12.5],
    goals: [1.5, 2.5, 3.5, 4.5],
    onShots: [5.5, 6.5, 7.5, 8.5, 9.5, 10.5, 11.5, 12.5, 13.5],
    totalShots: [18.5, 19.5, 20.5, 21.5, 22.5, 23.5, 24.5, 25.5, 26.5, 27.5, 28.5, 29.5, 30.5, 31.5],
    cards: [1.5, 2.5, 3.5, 4.5, 5.5, 6.5],
    results: [],
    btts: [],
    trends: [0, 10, 20, 30, 40, 50, 60]
  };
  const isTeamOrOpponent = scope === "team" || scope === "opponent";
  let options: Array<any> = []
  if(statType !== "") {
    options = isTeamOrOpponent ? thresholds.team[statType] : thresholds[statType]
  }

  useEffect(() => {
    setselectedThreshold(threshold);
  }, [threshold]);

  const handleChange = (value: number | string) => {
    onFilterChange({ threshold: value as number});
    setselectedThreshold(value as number);
  };

  return (
    <>
      {options?.length > 0 && 
        <FilterSelect
          label={f("threshold")}
          options={options.map((value: number) => ({ value, label: (value === 0 ? f('all') : value.toString()) }))}
          onChange={handleChange}
          value={selectedThreshold}
          disabled={disabled}
        />
      }
    </>
  );
};

export default ThresholdFilter;
